package fr.xibalba.generateurClassesLycee.pages.fichier

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Checkbox
import fr.xibalba.generateurClassesLycee.Fichier
import fr.xibalba.generateurClassesLycee.GlobalData
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.w3c.files.File
import org.w3c.files.FileReader
import org.w3c.files.get

@Page
@Composable
fun FichierPage() {
    var fileName by remember { mutableStateOf<String?>(null) }
    var rowCount by remember { mutableStateOf<Int?>(null) }
    var fileContent by remember { mutableStateOf<String?>(null) }
    var hasHeader by remember { mutableStateOf(false) }
    var isFileSaved by remember { mutableStateOf(false) }
    val ctx = rememberPageContext()

    LaunchedEffect(GlobalData.fichier) {
        // Load file details from IndexedDB if available
        if (GlobalData.fichier != null) {
            fileName = GlobalData.fichier!!.name
            fileContent = GlobalData.fichier!!.content
            rowCount = GlobalData.fichier!!.content.lines().size - 1 // Assuming first line is header
            hasHeader = GlobalData.fichier!!.hasHeader
            isFileSaved = true
        }
    }

    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Column(Modifier.padding(16.px), horizontalAlignment = Alignment.CenterHorizontally) {
            if (isFileSaved) {
                P { Text("Fichier chargé : $fileName") }
                P { Text("Nombre de lignes : $rowCount") }
                Box(Modifier.padding(8.px))
                Button({
                    fileName = null
                    rowCount = null
                    fileContent = null
                    hasHeader = false
                    isFileSaved = false
                    GlobalData.setFichier(null)
                }) {
                    Text("Supprimer le fichier")
                }
                Button({
                    ctx.router.navigateTo("/fichier/nettoyage")
                }, Modifier.margin(top = 8.px)) {
                    Text("Passer à l'étape suivante")
                }
            } else {
                Text("Veuillez télécharger un fichier CSV pour la liste des élèves.")
                Box(Modifier.padding(8.px))
                Input(type = InputType.File, attrs = {
                    attr("accept", ".csv")
                    onInput {
                        val file = it.target.files?.get(0)
                        if (file != null) {
                            handleFileUpload(file) { name, content ->
                                fileName = name
                                fileContent = content
                            }
                        }
                    }
                })
                Box(Modifier.padding(8.px))
                Checkbox(checked = hasHeader, onCheckedChange = { checked -> hasHeader = checked }) {
                    Text("Le fichier CSV contient une ligne d'en-tête")
                }
                Box(Modifier.padding(8.px))
                Button({
                    if (fileName != null && fileContent != null) {
                        rowCount = fileContent!!.lines().size - if (hasHeader) 1 else 0
                        isFileSaved = true
                        GlobalData.setFichier(Fichier(fileName!!, fileContent!!, hasHeader))
                    }
                }, enabled = fileName != null && fileContent != null) {
                    Text("Valider")
                }
            }
        }
    }
}

private fun handleFileUpload(file: File, onComplete: (String, String) -> Unit) {
    val reader = FileReader()
    reader.onload = {
        val content = reader.result as String
        onComplete(file.name, content)
    }
    reader.readAsText(file)
}